import type { Board, Board_PermissionLevel } from '@trello/model-types';

/**
 * Checks if the board is a Template board.
 */
export function checkIsTemplate({
  isTemplate,
  permissionLevel,
  premiumFeatures,
}: {
  isTemplate?: boolean;
  permissionLevel?: Board_PermissionLevel;
  premiumFeatures?: Board['premiumFeatures'];
}) {
  if (!isTemplate) {
    return false;
  } else if (
    permissionLevel === 'public' ||
    premiumFeatures?.includes('privateTemplates')
  ) {
    return true;
  }

  return false;
}
